$(function() {
  $('.navbar-collapse')
    .on('hide.bs.collapse', function(evt) {
      $(evt.target)
        .css({
          right: '100%',
          left: '-100%',
          transition: 'height 0s, visibility 0s, left 0.3s, right 0.3s'
        })
        .find('.dropdown')
        .removeClass('open');
    })
    .on('show.bs.collapse', function(evt) {
      $(evt.target).css({
        right: '0',
        left: '0',
        transition: 'height 0s, visibility 0s, left 0.3s, right 0.3s !important'
      });
    });

  if ($(window).width() < 992) {
    $('.navbar-collapse li.dropdown > a').click(function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      var menuItem = $(evt.target).hasClass('dropdown')
        ? $(evt.target)
        : $(evt.target).closest('.dropdown');
      $('.navbar-collapse .dropdown')
        .removeClass('open')
        .find('.dropdown-menu')
        .css({ left: '100%' });
      if (!menuItem.hasClass('open')) {
        menuItem
          .addClass('open')
          .find('.dropdown-menu')
          .animate(
            {
              left: '0'
            },
            300
          );
      } else {
        menuItem
          .removeClass('open')
          .find('.dropdown-menu')
          .animate(
            {
              left: '100%'
            },
            300
          );
      }
    });

    $('.navbar-collapse li.dropdown .dropdown-menu .back').click(function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      var menuItem = $(evt.target).hasClass('dropdown')
        ? $(evt.target)
        : $(evt.target).closest('.dropdown');
      $('.navbar-collapse .dropdown')
        .removeClass('open')
        .find('.dropdown-menu')
        .animate({ left: '100%' }, 300);
    });
  }

  $('#primary-menu-upper li.search').click(function(evt) {
    evt.preventDefault();
    $('#search-modal').modal('show');
  });

  $(window).resize(function() {
    if (!$('button[data-target="#primary-nav"]').is(':visible')) {
      $('.navbar-collapse li.dropdown')
        .removeClass('open')
        .find('.dropdown-menu')
        .css({ right: '0', left: 'auto' });
    }
  });
});
